import magicStyles from './faq-categories.magic.css.js';
import FaqCategoriesComponent from './faq-categories.js';
import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';

const __vue_script__ = FaqCategoriesComponent;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "wrapper",
      attrs: { part: "wrapper", "data-v-test-id": "faq-categories" }
    },
    [
      _vm.isLoading
        ? _c("magic-ui-loader", {
            staticClass: "loader",
            attrs: { part: "loader" }
          })
        : _c(
            "div",
            { staticClass: "menu-list", attrs: { part: "menu-list" } },
            _vm._l(_vm.categories, function(ref) {
              var id = ref.id;
              var title = ref.title;
              var slug = ref.slug;
              return _c(
                "magic-ui-menu-item",
                {
                  key: id,
                  staticClass: "menu-item",
                  attrs: {
                    "less-padding": "",
                    part: "menu-item",
                    "data-v-test-id": "faq-categories-menu-item"
                  }
                },
                [
                  _c("magic-router-link", {
                    staticClass: "link",
                    attrs: {
                      part: "link",
                      to: {
                        route: _vm.RoutablePage.FAQ_CATEGORY,
                        params: {
                          categorySlug: slug
                        }
                      }
                    },
                    domProps: { innerHTML: _vm._s(title) }
                  })
                ],
                1
              )
            }),
            1
          )
    ],
    1
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-4fba336a_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-4fba336a";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
